/* Public catalog metadata only; no member data or report resources are fetched. */
(function () {
    'use strict';
    if (!document.querySelector('[data-catalog-slug], [data-series-directory]')) return;
    function node(tag, text, className) {
        var result = document.createElement(tag);
        result.textContent = text;
        if (className) result.className = className;
        return result;
    }
    function seriesMeta(series) {
        // A planned directory date is not a published research update.
        return series.article_count + ' 篇文章 · ' + (series.status === 'planned' && !series.article_count
            ? '正文待发布 · 目录更新 ' : '最近实质更新 ') + series.updated_date;
    }
    function renderUpdates(directory, series) {
        var panel = directory.querySelector('[data-topic-updates]');
        if (!panel) return;
        var list = panel.querySelector('[data-update-list]');
        list.textContent = '';
        var articles = series.articles.slice().sort(function (a, b) {
            return b.updated_date.localeCompare(a.updated_date) || a.order - b.order;
        });
        panel.querySelector('[data-update-count]').textContent = articles.length ? '（' + articles.length + ' 条最新记录）' : '';
        var empty = panel.querySelector('[data-update-empty]');
        empty.hidden = !!articles.length;
        empty.textContent = '暂无已发布章节，正文确认发布后才会出现新增或修订记录。';
        articles.forEach(function (article) {
            var li = node('li', '');
            li.dataset.updateSlug = article.slug;
            var meta = node('div', '', 'tars-update-meta');
            var date = node('time', article.updated_date); date.dateTime = article.updated_date;
            var kind = article.updated_date > article.published_date ? '内容修订'
                : article.updated_date === article.published_date ? '章节发布' : '内容更新';
            meta.appendChild(date); meta.appendChild(node('span', kind)); li.appendChild(meta);
            var content = node('div', '', 'tars-update-content');
            var link = node('a', article.title, 'tars-update-title'); link.href = article.research_url;
            content.appendChild(link);
            var description = node('p', '', 'tars-update-description');
            var change = (article.change_summary || '').trim();
            description.appendChild(node('span', change ? '变更说明：' : '研究摘要：', 'tars-update-description-label'));
            description.appendChild(document.createTextNode(change || article.summary || '暂无公开摘要。'));
            content.appendChild(description); li.appendChild(content); list.appendChild(li);
        });
    }
    function load() {
    (window.TarsResearchCatalog || fetch('/research/research-catalog/catalog.json', {credentials: 'omit', cache: 'no-cache'}).then(function (response) {if (!response.ok) throw new Error('catalog unavailable'); return response.json();}))
        .then(function (catalog) {
            catalog.series.forEach(function (series) {
                document.querySelectorAll('[data-catalog-slug]').forEach(function (card) {
                    if (card.dataset.catalogSlug !== series.slug) return;
                    var label = card.querySelector('[data-series-meta]');
                    if (label) label.textContent = seriesMeta(series);
                    var date = card.querySelector('time');
                    if (date && label) date.hidden = true;
                });
                document.querySelectorAll('[data-series-directory]').forEach(function (directory) {
                    if (directory.dataset.seriesDirectory !== 'hash-series-id-' + series.id) return;
                    directory.querySelector('[data-directory-meta]').textContent = seriesMeta(series) + '。章节按推荐阅读顺序排列。';
                    renderUpdates(directory, series);
                    var container = directory.querySelector('.tars-chapter-groups');
                    var groups = new Map();
                    series.articles.forEach(function (article) {
                        var chapter = Array.from(container.querySelectorAll('[data-chapter-slug]')).find(function (el) { return el.dataset.chapterSlug === article.slug; });
                        if (!chapter) {
                            // Ghost get helpers return at most 100 posts; the safe
                            // metadata index can still render an expanding topic.
                            chapter = node('article', '', 'tars-chapter');
                            chapter.dataset.chapterSlug = article.slug;
                            var heading = node('h3', '');
                            var titleLink = node('a', article.title, 'tars-chapter-primary'); titleLink.href = article.research_url;
                            heading.appendChild(titleLink); chapter.appendChild(heading);
                            chapter.appendChild(node('p', article.summary));
                            var footer = node('footer', ''); footer.appendChild(node('span', ''));
                            footer.appendChild(node('span', '阅读全文 →', 'tars-chapter-action'));
                            var previewLink = node('a', '文章概要', 'tars-chapter-preview'); previewLink.href = article.url;
                            footer.appendChild(previewLink); chapter.appendChild(footer);
                            container.appendChild(chapter);
                        }
                        if (!groups.has(article.section)) {
                            var group = node('section', '', 'tars-chapter-group');
                            group.appendChild(node('h3', article.section, 'tars-chapter-section'));
                            var grid = node('div', '', 'tars-chapter-grid');
                            group.appendChild(grid); container.appendChild(group); groups.set(article.section, grid);
                        }
                        chapter.querySelector('.tars-chapter-primary').href = article.research_url;
                        chapter.querySelector('footer span').textContent = (article.visibility === 'public' ? '公开研究' : '受限研究 · 登录后阅读') + ' · 内容更新 ' + article.updated_date;
                        groups.get(article.section).appendChild(chapter);
                    });
                });
            });
        }).catch(function () { /* Server-rendered topic and article links remain usable. */ });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
}());
